import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { State } from '@app/shared/helpers/store';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@app/../environments/environment';

interface ILanguage{
  langID: number,
  langCode: string,
  langName: string
}

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  public languagesData$: State<ILanguage[]>;
  public languages$: Observable<any>;
  public endpoint: string = `${environment.apiUrl}/languages`;
  public languages: string[] = ['en-ca', 'fr-ca', 'es-es']
  public defaultLanguage = 'en-ca';
  // public defaultLanguageData$: State<any>;
  // public defaultLanguage$: Observable<any>;
  constructor(
    
    public _translateService: TranslateService,
    public _http: HttpClient
    ) {
    this.languagesData$ = new State([]);
    // this.defaultLanguageData$ = new State('en-ca');
    // this.defaultLanguage$ = select$(this.languagesData$, data => data);

  }

  init() {
    this._translateService.addLangs(this.languages);
    this._translateService.setDefaultLang(this.defaultLanguage);
    let browserLang = this._translateService.getBrowserCultureLang().toLocaleLowerCase();
    browserLang = browserLang.match(/ar-ae|en-ca|fr-ca|es-es/) ? browserLang : this.defaultLanguage;
    this._translateService.use(browserLang || this.defaultLanguage);
  }

  setLang(lang: string) {
    this._translateService.use(lang);
  }

}
